import React from 'react';
import { Link } from 'react-router-dom';

const FolliaThankYou = () => {
  return (
    <div className="min-h-screen bg-black text-white flex flex-col items-center justify-center p-6">
      <img 
        src="/logo-follia.png" 
        alt="Follia Logo" 
        className="w-64 h-auto mb-6"
      />

      <h1 className="text-2xl font-bold text-center mb-4">
        Grazie per esserti registrato
      </h1>

      <p className="text-center text-lg mb-6">
        Potrai ordinare comodamente dal tavolo
      </p>

      <p className="text-center text-sm opacity-60">
        #stayconnected
      </p>
    </div>
  );
};

export default FolliaThankYou;
